import { combineReducers } from "@reduxjs/toolkit";
import agreementSlice from "./agreementSlice";
import userSlice from "./userSlice";
import dictionariesSlice from "./dictionariesSlice";
import pageSlice from "./pageSlice";

export default combineReducers({
  agreement: agreementSlice,
  user: userSlice,
  dictionaries: dictionariesSlice,
  page: pageSlice,
});
